import React from "react";
import { Link } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import REGISTER_IMAGE from "assets/login-page.jpg";
import { RegisterForm } from "./register-form";

import styles from "./register.module.scss";

export const Register = () => {
  return (
    <div className={styles.register_container}>
      <img
        className={styles.image_container}
        src={REGISTER_IMAGE}
        alt="register_IMAGE"
      />
      <Row>
        <Col md={6} xs={12} lg={4} className={styles.register_form_container}>
          <div className={styles.form_container}>
            <h1>ثبت نام اولیه پولبان</h1>
            <h2 className="link link-primary">
              <Link to="/"> پولبان</Link>
            </h2>
            <div className="my-4">
              <RegisterForm />
            </div> 
          </div>
        </Col>
      </Row>
    </div>
  );
};
